export default __webpack_public_path__ + "static/media/3.2e9ac554.jpeg";